import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnboardGuard implements CanActivate {

  constructor(private router: Router) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
 

    if (localStorage.getItem('onboarding') == 'true') {
      this.router.navigate(['/login']);
      return false; // El usuario no tiene permiso para acceder
    } else {
      // Redirige al usuario a la página de inicio de sesión
      return true; 
    }
  }
  
}
